import React, {Component} from 'react';
import {CardElement, injectStripe} from 'react-stripe-elements';
import './CheckoutFormStyle.css';
import queryString from 'query-string';
import { connect } from 'react-redux';
import api from '../services/api';
import * as actions from '../actions';
import { css } from 'react-emotion';
// First way to import
import { ClipLoader } from 'react-spinners';
import { Delete } from '@material-ui/icons';


const override = css`
    margin: 10px;
`;

const sourceDeletionLoading = css`
  margin-top: 10px;
  `;

class CheckoutForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      buttonDisabled: false,
      complete: false,
      plan: queryString.parse(this.props.location.search).plan || 'Annually',
      useSavedCard: false,
      savedCardId: this.props.default_source,
      sourceBeingDeleted: null,
      submitDisabled: false
    };
    this.submit = this.submit.bind(this);
  }

  deleteSource = async (source_id) => {
    this.setState({submitDisabled: true});
    this.setState({sourceBeingDeleted: source_id});
    await this.props.deleteSource(source_id);

    await Promise.all(
      [
        this.props.getUserPremiumStatus(),
        this.props.getStripeDetails(),
      ]
    );

    if(this.props.default_source === null || this.props.default_source === '') {
      this.setState({savedCardId: this.props.default_source});
    } else {
      this.setState({submitDisabled: false});
    }

    this.setState({sourceBeingDeleted: null});


  }

  submit = async (ev) => {
    if (this.props.stripe_plans_dict_by_name[this.state.plan] === undefined) {
      alert('Please select a plan.');
      return;
    }
    this.setState({buttonDisabled: true});

    let source_id;
    let card;
    if(this.state.useSavedCard) {
      source_id = this.state.savedCardId;
      card = null;
    } else {
      let source = await this.props.stripe.createSource({
        type: 'card',
        currency: 'usd',
        owner: {
          email: this.props.email
        }
      });
      if (source.error) {
        alert(source.error.message);
        this.setState({buttonDisabled: false});
        return;
      }
      source_id = source.source.id;

      card = {
        last4: source.source.card.last4,
        exp_year: source.source.card.exp_year,
        exp_month: source.source.card.exp_month,
        brand: source.source.card.brand
      };
    }

    await this.props.createSubscription(
      source_id,
      card,
      this.props.email,
      this.props.stripe_plans_dict_by_name[this.state.plan].plan_id,
      this.props.stripe_plans_dict
    );


    this.setState({buttonDisabled: false});
    this.props.getUserPremiumStatus();
    this.props.getStripeDetails();

  }

  toggleSavedCard = (val) => {
    this.setState({useSavedCard: val});
    if(val === true && (this.state.savedCardId === null || this.state.savedCardId === '')){
      this.setState({submitDisabled: true});
    } else {
      this.setState({submitDisabled: false});
    }
  }

  setCard = (source_id) => {
    this.setState({savedCardId: source_id});
    this.setState({submitDisabled: false});
  }

  renderCard = (source) => {
    return (
      <div key={source.source_id} className="flex-container" style={{ alignItems: 'center', marginBottom: '10px' }}>
        <div className={"saved-card  " + ((this.state.savedCardId === source.source_id) ? 'active' : 'inactive')}
          onClick={() => {this.setCard(source.source_id)}}>
          <div className="flex-container saved-card-header" style={{ justifyContent: 'space-between' }}>
            <div className="flex-container">{source.brand} ending in {source.last_four}</div>
            <div className="flex-container">expires: {source.exp_month}/{source.exp_year}</div>
          </div>
        </div>
        {this.state.sourceBeingDeleted === source.source_id ? (
          <ClipLoader
            className={sourceDeletionLoading}
            sizeUnit={"px"}
            size={18}
            color={'#123abc'}
          />
        ) : (
          <Delete style={{ height: '46px', cursor: 'pointer' }} onClick={() => {this.deleteSource(source.source_id)}}></Delete>
        )}
      </div>
    )
  }

  renderCards = (sources) => {
    return sources.map((source, index) => {
      return (
        this.renderCard(source)
      )
    });
  }

  render() {
    if (this.state.complete) return <h1>Purchase Complete</h1>;

    return (
      <div className="flex-container box" style={{ padding: '20px', marginTop: '50px', marginBottom: '50px' }}>
        <div className="flex-container" style={{ justifyContent: 'center', fontSize: '24px', marginTop: '40px', marginBottom: '40px' }}>
          Try premium for free for 7 days
        </div>
        <div className="flex-container" style={{ flexDirection: 'row' }}>
          <div
            className={"flex-container subscription-plan " + ((this.state.plan === 'Annually') ? 'active' : 'inactive')}
            onClick={() => {this.setState({plan: 'Annually'})}}>
            <div className="flex-container plan-header" style={{ justifyContent: 'center' }}>Annually</div>
            <div className="flex-container plan-body" style={{ flexDirection: 'column',
              justifyContent: 'space-between',
              alignItems: 'center' }}>
              <div className="flex-container">$49.99/year</div>
            </div>
          </div>
          <div
            className={"flex-container subscription-plan " + ((this.state.plan === 'Monthly') ? 'active' : 'inactive')}
            onClick={() => {this.setState({plan: 'Monthly'})}}>
            <div className="flex-container plan-header" style={{ justifyContent: 'center' }}>Monthly</div>
            <div className="flex-container plan-body" style={{ justifyContent: 'center' }}>
              $5.99/month
            </div>
          </div>
        </div>
        <div className="flex-container" style={{ marginTop: '30px', flexDirection: 'column', alignItems: 'center' }}>
          {this.state.useSavedCard ? (
            <label>
              {this.renderCards(this.props.sources)}
            </label>
            ) : (
              <label>
                <CardElement style={{
                  base: {
                      iconColor: '#666EE8',
                      color: 'black',
                      height: '40px',
                      lineHeight: '40px',
                      fontWeight: 300,
                      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                      fontSize: '18px',
                      border: '1px solid black',

                      '::placeholder': {
                          color: 'black',
                      }
                  }
                }}
              />
              </label>
            )
          }

          { this.state.useSavedCard &&
            <button className='saved-card-button'
              onClick={() => {this.toggleSavedCard(false)}}
              style={{ fontSize: '13px' }}
            >
              Add New Card?
            </button>
          }
          {this.props.sources.length > 0 && !this.state.useSavedCard && (
            <button className='saved-card-button'
              onClick={() => {this.toggleSavedCard(true)}}
              style={{ fontSize: '13px' }}
            >
              Use Saved Card?
            </button>
          )}

          {this.state.buttonDisabled ? (
            <ClipLoader
              className={override}
              sizeUnit={"px"}
              size={40}
              color={'#123abc'}
            />
          ) : (
            <button className='submit-button'
              onClick={this.submit}
              disabled={this.state.submitDisabled}>
              Subscribe
            </button>
          )}
          <div style={{ fontSize: '14px' }}>
            Cancel your subscription at any time.
          </div>
        </div>
      </div>
    );
  }
}

function mapStatetoProps(state) {
  return {
    authenticated: state.auth.authenticated,
    email: state.user.user_personal_details.email,
    sources: state.premium.sources,
    default_source: state.premium.default_source,
    stripe_plans_dict: state.premium.stripe_plans_dict,
    stripe_plans_dict_by_name: state.premium.stripe_plans_dict_by_name
  };
}

export default injectStripe(connect(mapStatetoProps, actions)(CheckoutForm));
